/*
 * @Description:
 * @version:
 * @Author: guyifeng
 * @Date: 2020-09-28 14:15:10
 * @LastEditors: guyifeng
 * @LastEditTime: 2020-10-13 15:45:01
 */
const env = process.env.DEP_ENV;

const STUDY_WEB = {
  prod: "https://study-web.xiguacity.cn",
  qa: "http://stable.study-web.nt.qa.xiguacity.cn",
  dev: "http://stable.study-web.nt.qa.xiguacity.cn",
};

export const SERVER_BFS = {
  dialogue: "teaching-dialogue",
  teachingMain: 'teaching-main',
};

export const DIALOGUE_SERVER = `${STUDY_WEB[env]}/${SERVER_BFS.dialogue}`;
export const SERVER = `${STUDY_WEB[env]}`;
export const TEACHING_SERVER = `${STUDY_WEB[env]}/${SERVER_BFS.teachingMain}`;

const HOST = {
  prod: "https://www.xiguacity.cn",
  qa: "http://xigua-testing.xiguacity.club",
  dev: "http://xigua-testing.xiguacity.club",
};
export const READIO_SERVER_HOST = HOST[env];
